export enum ListingChannelSnapshotFailureReason {
    GENERIC_ERROR = 0,
    AUTHENTICATION_ERROR = 1,
}

export const ListingChannelSnapshotFailureReasonTranslationMap: Record<ListingChannelSnapshotFailureReason, string> = {
    [ListingChannelSnapshotFailureReason.GENERIC_ERROR]: 'channelSnapshots.notifications.failureReason.genericError',
    [ListingChannelSnapshotFailureReason.AUTHENTICATION_ERROR]: 'channelSnapshots.notifications.failureReason.authenticationError',
};
